module.exports = __webpack_public_path__ + "img/ntk_nav_right_g.94438cd2.svg";